export default __webpack_public_path__ + "assets/sharing.ba58205ca44c9ebb0d17d340eeddea98.png";